import React, { Component } from 'react';
import { Tabs } from 'antd';

import CustomerForm from './components/CustomerForm/CustomerForm';
import CustomerEnrollmentHistory from './components/CustomerEnrollmentHistory/CustomerEnrollmentHistory';
import CustomerInsight from './components/CustomerInsight/CustomerInsight';

const TabPane = Tabs.TabPane;

export class CustomerManagementPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: 'detail'
        };
    }

    componentDidMount() {
        const { location } = this.props;
        const { hash } = location;

        if (hash) {
            this.setState({ activeTab: hash.substring(1) })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { location } = this.props;
        const { hash } = location;

        if (hash !== prevProps.location.hash)
            this.setState({ activeTab: hash.substring(1) })
    }

    render() {
        const { location, history, match } = this.props;
        const { activeTab } = this.state;
        const isCreateNewCustomer = match.params.customerId === undefined;

        return (
            <div className="ManagementPage">
                <h2>{isCreateNewCustomer ? 'Create New Customer' : 'Edit Customer'}</h2>
                <Tabs 
                    activeKey={activeTab}
                    type="card" 
                    tabBarGutter={5}
                    onChange={(key) => history.push(`${location.pathname}#${key}`)}
                >
                    <TabPane tab="Detail" key="detail">
                        <CustomerForm/>
                    </TabPane>
                    {
                        !isCreateNewCustomer &&
                        <TabPane tab="History" key="history">
                            <CustomerEnrollmentHistory/>
                        </TabPane>
                    }
                    {
                        !isCreateNewCustomer &&
                        <TabPane tab="Insight" key="insight">
                            <CustomerInsight/>
                        </TabPane>
                    }
                </Tabs>
            </div>
        );
    }
}

export default CustomerManagementPage;


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/CustomerManagementPage/CustomerManagementPage.js